import React from "react";
import { Spinner } from "react-bootstrap";

export const CardLoader: React.FC = () => {
  return (
    <div
      className={`card pt-3 pb-3`}
      style={{ minHeight: "8rem", maxHeight: "9rem" }}
    >
      <div className="card-body d-flex align-items-center justify-content-center">
        <Spinner variant="secondary" />
      </div>
    </div>
  );
};

export const DataSectionLoader3Rows = () => {
  return (
    <>
      <div className="row">
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
      </div>
    </>
  );
}

export const DataSectionLoader = () => {
  return (
    <>
      <div className="row">
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg-3 col-sm-12">
          <CardLoader />
        </div>
      </div>
      <div className="row">        
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
        <div className="col-lg col-sm-12">
          <CardLoader />
        </div>
      </div>
    </>
  );
};
